export const CONFIG = {
  BG_VIDEO: import.meta.env.VITE_BG_VIDEO,
  HOST:
    import.meta.env.VITE_ENVIRONMENT === 'local'
      ? import.meta.env.VITE_HOST_URL_LOCAL
      : import.meta.env.VITE_HOST_URL,
};
